import InsuranceDetails from './InsuranceDetails';
export default InsuranceDetails;
